module.exports = require("./dist/jquery.js");


//////////////////
// WEBPACK FOOTER
// jquery (bower component)
// module id = 112
// module chunks = 1